import React from 'react'
import styles from './styles.css'
import Paginated from 'meteor-paginated-graphql-react'
import autobind from 'autobind-decorator'
import {withRouter} from 'react-router'
import PropTypes from 'prop-types'
import Loading from 'orionsoft-parts/lib/components/Loading'
import moment from 'moment'
import Actions from 'App/components/Actions'
import TagsFilter from '../../../components/fields/TagsFilter'
import withOrganization from 'App/Decorators/withOrganization'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import Button from 'orionsoft-parts/lib/components/Button'
import MdArchive from 'react-icons/lib/md/archive'
import {isMobile} from 'src/App/components/Devices/mediaCheckers'
import MdSend from 'react-icons/lib/md/send'
import SignersStatus from '../Common/SignersStatus'
import docIcon from '../Common/docIcon'

@withOrganization
@withRouter
@withMessage
@withMutation(gql`
  mutation archiveDocument($documentId: ID, $organizationId: ID) {
    archiveDocument(documentId: $documentId, organizationId: $organizationId) {
      success
    }
  }
`)
@withMutation(gql`
  mutation alertAll {
    alertAll {
      success
    }
  }
`)
@withMutation(gql`
  mutation createAlert($documentId: String) {
    createAlert(documentId: $documentId) {
      success
    }
  }
`)
export default class Main extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    organization: PropTypes.object,
    archiveDocument: PropTypes.func,
    alertAll: PropTypes.func,
    createAlert: PropTypes.func,
    showMessage: PropTypes.func
  }

  @autobind
  onSelect({_id}) {
    this.props.router.push(`/documents/${_id}`)
  }

  getFields() {
    if (isMobile()) {
      return [
        {
          title: 'Nombre',
          name: 'name, documentStatus{status}',
          render: ({name, documentStatus}) => <div className="d-flex" data-mobile-label="Nombre">{docIcon(documentStatus)} {name}</div>
        },
        {
          title: 'Firmas',
          name: 'signersStatus{email, didSign}, feasStatus{email, didSign}, biosStatus{email, didSign}, faceStatus{email, didSign}',
          render: ({signersStatus, feasStatus, biosStatus, faceStatus}) =>
            SignersStatus(signersStatus, feasStatus, biosStatus, faceStatus)
        },
        {
          title: 'Fecha',
          name: 'createdAt',
          render: ({createdAt}) => <div data-mobile-label="Fecha">{moment(createdAt).format('DD/MM/YYYY HH:mm')}</div>,
          defaultSort: 'DESC',
          sort: 'DESC'
        },
        {
          title: 'Tags',
          name: 'tags',
          render: ({tags}) => <div data-mobile-label="Tags">{ tags ? tags.join(' ') : "" }</div>
        },
        {
          title: '',
          name: '',
          render: item => this.renderActions(item),
          defaultSort: 'DESC',
          sort: 'DESC'
        }
      ]
    }
    return [
      {
        title: '',
        name: 'documentStatus{status}',
        render: ({documentStatus}) => docIcon(documentStatus)
      },
      {
        title: 'Nombre',
        name: 'name',
        sort: 'DESC'
      },
      {
        title: 'Firmas',
        name: 'signersStatus{email, didSign}, feasStatus{email, didSign},  biosStatus{email, didSign}, faceStatus{email, didSign}',
        render: ({signersStatus, feasStatus, biosStatus, faceStatus}) =>
          //this.renderSignerStatus(signersStatus, feasStatus, documentStatus)
          SignersStatus(signersStatus, feasStatus, biosStatus, faceStatus)
      },
      {
        title: 'Fecha',
        name: 'createdAt',
        render: ({createdAt}) => moment(createdAt).format('DD/MM/YYYY HH:mm'),
        defaultSort: 'DESC',
        sort: 'DESC'
      },
      {
        title: 'Tags',
        name: 'tags',
        render: ({tags}) => tags ? tags.join(' ') : ""
      },
      {
        title: '',
        name: '',
        render: item => this.renderActions(item)
      }
    ]
  }

  renderActions(item) {
    return (
      <div>
        <span>
          <Actions options={this.renderOptions(item)} />
        </span>
      </div>
    )
  }

  renderOptions(item) {
    let status = item.documentStatus.status
    let typeStatus = {sent: 'sent', feaFlow:'feaFlow'}

    if(typeStatus[status]) return [this.renderArchive(item), this.renderAlert(item)]
    return [this.renderArchive(item)]
  }

  renderArchive(item) {
    return (
      <div onClick={() => this.archiveDocument(item)} style={{width: 200}}>
        <span>
          <div className="row">
            <div className="col-xs-12 col-sm-2">
              <MdArchive size={20} />
            </div>
            <div className="col-xs-12 col-sm-9">Archivar documento</div>
          </div>
        </span>
      </div>
    )
  }

  renderAlert(item) {
    return (
      <div onClick={() => this.alert(item)} style={{width: 200}}>
        <span>
          <div className="row">
            <div className="col-xs-12 col-sm-2">
              <MdSend size={20} style={{color: 'blue'}} />
            </div>
            <div className="col-xs-12 col-sm-9">Recordar firma</div>
          </div>
        </span>
      </div>
    )
  }

  async alert(item) {
    this.setState({loading: true, errorMessages: null})
    try {
      await this.props.createAlert({documentId: item._id})
      this.props.showMessage('Recordatorio de firma enviado')
    } catch (error) {
      this.props.showMessage(error.message, {level: 'error'})
    }
    this.setState({loading: false})
  }

  async remindAll() {
    this.setState({loading: true, errorMessages: null})
    try {
      await this.props.alertAll();
      this.props.showMessage('Recordatorios de firma enviados')
    } catch (error) {
      this.props.showMessage(error.message, {level: 'error'})
    } 
    this.setState({loading: false})
  }

  async archiveDocument(item) {
    try {
      await this.props.archiveDocument(
        {
          documentId: item._id,
          organizationId: this.props.organization._id
        },
        {
          refetchQueries: ['documentCount', 'organizationDocCount']
        }
      )
      this.props.showMessage('Documento archivado')
    } catch (e) {
    } finally {
      this.refs.paginated.reload()
    }
  }

  renderTooltipDocument(documentStatus) {
    if (documentStatus.status === 'ready') {
      return <p>Documento firmado</p>
    } else if (documentStatus.status === 'bioFlow') {
      return <p>Esperando autorizaciones biométricas</p>
    } else if (documentStatus.status === 'feaFlow') {
      return <p>Esperando firmas electrónicas avanzadas</p>
    } else if (documentStatus.status === 'sent') {
      return <p>Esperando firmas del documento</p>
    } else if (documentStatus.status === 'personal') {
      return <p>Documento personal</p>
    } else {
      return <p>Documento no enviado para firmar</p>
    }
  }

  render() {
    console.log("renderizando Main documents");
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="table">
            <Paginated
              loadingComponent={Loading}
              headRightComponent={TagsFilter}
              queryName="documents"
              defaultLimit={25}
              fields={this.getFields()}
              params="$filter: String $organization: String"
              organization={this.props.organization._id}
              ref="paginated"
              onPress={this.onSelect}
            />
          </div>
        </div>
        <div className={styles.button}>
          <Button primary onClick={() => this.props.router.push('/documents/massiveupload')}>
            Importación masiva
          </Button>
          <Button primary onClick={() => this.remindAll()}>
            Recordar Todos
          </Button>
          
          <Button primary onClick={() => this.props.router.push('/documents/massivefea')}>
            FEA Masivo
          </Button>
          <Button primary onClick={() => this.props.router.push('/documents/massivedactilar')}>
            Dactilar Masivo
          </Button>
          
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Main/index.js